import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from '../common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { EERIE, GYPSUM } from 'HubStyleTokens/colors';
import { track } from '../common/eventTracking/tracker'; // @ts-expect-error not migrated to TS

import { getInlineMeetingParams } from '../common/api/meetingHelpers';
import { StyledModal } from '../common/components/StyledModal';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
const TRUSTED_DOMAINS = ['https://www.hubspot.com', 'https://hubspot.com', 'https://app.hubspot.com', 'https://meetings.hubspot.com', 'https://meetings.hubspotqa.com'];

const MeetingModal = ({
  hideBackground,
  onClose,
  upgradeData,
  isUpgradePoint,
  repInfo
}) => {
  const {
    link: linkBase
  } = repInfo;
  const meetingLink = `${linkBase}?${getInlineMeetingParams(upgradeData, repInfo)}`;
  useEffect(() => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'shown booking page',
      meetingLink,
      repName: getRepName(repInfo)
    }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));

    const handleMessages = e => {
      const isKnownOrigin = TRUSTED_DOMAINS.includes(e.origin);
      if (!isKnownOrigin) return;

      if (e.data.meetingBookSucceeded) {
        track('communicationMethodsInteraction', Object.assign({
          action: 'meeting booked successfully',
          meetingLink,
          repName: getRepName(repInfo)
        }, getUpgradeDataTrackingProperties(upgradeData, isUpgradePoint)));
      }
    };

    window.addEventListener('message', handleMessages);
    return () => window.removeEventListener('message', handleMessages);
  }, [upgradeData, meetingLink, isUpgradePoint, repInfo]);
  return /*#__PURE__*/_jsxs(StyledModal, {
    "data-test-id": "meeting-modal",
    use: "conversational",
    width: 900,
    hideBackground: hideBackground,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      style: {
        backgroundColor: GYPSUM
      },
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => onClose(),
        color: EERIE
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        backgroundColor: GYPSUM,
        paddingTop: '64px'
      },
      children: /*#__PURE__*/_jsx("iframe", {
        id: "meetingModal",
        "data-test-id": "tts-modal",
        width: "900",
        height: "800",
        src: meetingLink,
        style: {
          border: '0px'
        }
      })
    })]
  });
};

MeetingModal.defaultProps = {
  hideBackground: false
};
MeetingModal.propTypes = Object.assign({
  hideBackground: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  repInfo: PropTypes.object
}, upgradeDataPropsInterface);
export default MeetingModal;